export class CompositePropertyRepository {
  constructor({ firestoreRepo, apiRepo }) {
    this.firestoreRepo = firestoreRepo;
    this.apiRepo = apiRepo;
  }

  searchViolations(cityId, options) { return this.apiRepo.searchViolations(cityId, options); }

  exportViolations(cityId, options) { return this.apiRepo.exportViolations(cityId, options); }

  pendingViolationLetters(cityId, options) { return this.apiRepo.pendingViolationLetters(cityId, options); }

  fetchAddresses(cityId, addressIds) {
    return this.firestoreRepo.fetchAddresses(cityId, addressIds);
  }

  propertiesSearch(city, options = {}) {
    return this.firestoreRepo.propertiesSearch(city, options);
  }
}
